$(document).ready(function() {

    $('div#myModalCompleteLook .cu__products').css('opacity', '0');
  
    $("#openModal").click(function() {
        $("#myModalCompleteLook").fadeIn(function() {
           $('div#myModalCompleteLook .cu__products').slick('setPosition');
           setTimeout(function() {
                $('div#myModalCompleteLook .cu__products').css('opacity', '1');
            }, 100);
        });
    });

    $(".modal-complete-look__close").click(function() {
        $("#myModalCompleteLook").fadeOut();
        $("div#myModalCompleteLook #message-add-to-cart").fadeOut();
    });


    $(document).on("click","div#myModalCompleteLook.open-modal-rebuy .modal-complete-look__close",function() {
        // const SmartCart = window.Rebuy.SmartCart;
        // SmartCart.hide(event);
        $("div#myModalCompleteLook").removeClass('open-modal-rebuy');
    });


    $(document).click(function(event) {
        
        if ($(event.target).closest(".modal-complete-look__container").length === 0 && $(event.target).is(".modal-complete-look__content")) {
            $("#myModalCompleteLook").fadeOut();
            $("div#myModalCompleteLook #message-add-to-cart").fadeOut();
    
            if ($("div#myModalCompleteLook").hasClass('open-modal-rebuy')) {
                // const SmartCart = window.Rebuy.SmartCart;
                // SmartCart.hide();
                $("div#myModalCompleteLook").removeClass('open-modal-rebuy');
            }
        }
    });


    let productCount = $('div#myModalCompleteLook product-card.product-card').length;
    $('#myModalCompleteLook').attr('data-products', productCount);


    if ($('div#myModalCompleteLook[data-products="0"]').length) {
        $('div#myModalCompleteLook[data-products="0"], button#openModal').remove();
    }

  

    $('div#myModalCompleteLook .cu__products').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
});